import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import LoginPage from "../auth-pages/LoginPage";

const CheckoutButton = () => {
  const navigate = useNavigate();
  const [showLogin, setShowLogin] = useState(false);
  const customer = JSON.parse(localStorage.getItem("customer"));

  const handleCheckout = () => {
    // ✅ Already logged in → go to checkout page
    if (customer) {
      navigate("/checkout");
    } else {
      // ❌ Not logged in → go to login page
      // navigate("/login");
      setShowLogin(true);
    }
  };

  return (
    <>
      <button
        className="btn btn-danger mt-5"
        style={{ backgroundColor: "#4c934c", color: "white" }}
        onClick={handleCheckout}
      >
        Process to Checkout
      </button>
      <LoginPage show={showLogin} onHide={() => setShowLogin(false)} />
    </>
  );
};

export default CheckoutButton;
